/**
 * Do not edit directly, this file was auto-generated.
 */

export const ColorTextPrimary = "#FFFFFF";
export const ColorTextSecondary = "#FFFFFF";
export const ColorBackgroundPrimary = "#161616";
export const ColorIconPrimary = "#FFFFFF";
export const ColorIconSecondary = "#FFFFFF";
